import React from 'react';
import Logo from '../Logo';
import data from '../logos/hsbc-global.js';

const LogoHsbcGlobal = (props) => <Logo {...props} data={data} />;

LogoHsbcGlobal.displayName = 'LogoHsbcGlobal';

export default LogoHsbcGlobal;
